export default "__VITE_ASSET__CX0uNLED__"